import React from 'react';
/* this is a wrapper around multiple fields to allow usage in search forms */


const ObjectField = (props)=> {
    const p = {...props};
    const value = props.value?props.value:props.blank;
    const onChange = (evt) => {
        const newValue = {...value};
        newValue[evt.target.name] = evt.target.value;
        props.onChange({target:{name:props.name,value:newValue}});
    }
    p.onChange = onChange;
    p.value = value;
    return <>{props.children(p)}</>;
}

export default ObjectField;